// Environment configuration for staging
export const environment = {
    production: false,
    environmentName: 'staging',
    apiUrl: '',
    debugMode: false,
    enableLogs: false, // Disable console logs for staging environment
    featureFlags: {
        enableAnalytics: true,
        enableExperimentalFeatures: false
    },
    services: {
        auth: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/auth/v1',
            auth0ClientId: 'aRDVty1ny5T6LjSVPBGndf5kJ3eids73',
            auth0Domain: 'login.staging.hundredxinc.com',
            auth0AudienceDomain: 'hundredxinc-stage.auth0.com',
            auth0CallbackURL: 'https://admin.staging.hundredx.com/login',
            federatedSignout: true
        },
        firebaseToken: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/auth/v1/firebase/token'
        },
        account: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/account/v1'
        },
        contact: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/contact/v1'
        },
        feedback: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/feedback/v1'
        },
        participant: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/participant/v1'
        },
        transaction: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/transaction/v1'
        },
        solution: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/solution/v1',
            efgAccountId: 1017 // Needs to be updated once one is made
        },
        cbreService: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/cbre/v1'
        },
        reporting: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/reporting/v1'
        },
        data: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/data/v1'
        },
        regionSync: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/region-sync'
        },
        masterData: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/master-data/v1'
        },
        plc: {
            baseUrl: 'https://api.staging.hundredxinc.com',
            basePath: '/plc/v1'
        }
    }
};